import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

type itemProps = {
  link: string;
  img: string;
  title: string;
  tech: string[];
};

const Project: React.FC<itemProps> = ({ link, img, title, tech }) => {
  return (
    <a href={link} target="_blank" className="projects__item">
      <div className="projects__item-img">
        <LazyLoadImage src={`./img/projects/${img}.png`} alt={title} />
      </div>
      <div className="projects__item-info">
        <h5>{title}</h5>
        <ul>
          {tech.map((skill, index) => (
            <li key={index}>{skill}</li>
          ))}
        </ul>
      </div>
    </a>
  );
};

export default Project;
